import type { SVGProps } from "react";

const baseProps: SVGProps<SVGSVGElement> = {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true
};

export function DashboardIcon() {
  return (
    <svg {...baseProps}>
      <rect x="2" y="2" width="5" height="6" rx="1" />
      <rect x="9" y="2" width="5" height="3" rx="1" />
      <rect x="9" y="7" width="5" height="7" rx="1" />
      <rect x="2" y="10" width="5" height="4" rx="1" />
    </svg>
  );
}

export function UsageIcon() {
  return (
    <svg {...baseProps}>
      <path d="M2 13h12" />
      <rect x="3.5" y="9" width="2" height="4" />
      <rect x="7" y="6" width="2" height="7" />
      <rect x="10.5" y="3" width="2" height="10" />
    </svg>
  );
}

export function KeysIcon() {
  return (
    <svg {...baseProps}>
      <circle cx="5.5" cy="8" r="2.5" />
      <path d="M8 8h6" />
      <path d="M12 8v2" />
      <path d="M14 8v2.5" />
    </svg>
  );
}

export function TemplatesIcon() {
  return (
    <svg {...baseProps}>
      <rect x="2.5" y="2" width="11" height="12" rx="1.5" />
      <path d="M5 5.5h6" />
      <path d="M5 8h6" />
      <path d="M5 10.5h3.5" />
    </svg>
  );
}

export function ReceiptsIcon() {
  return (
    <svg {...baseProps}>
      <path d="M4 2h8v12l-2-1.2L8 14l-2-1.2L4 14V2z" />
      <path d="M6 5.5h4" />
      <path d="M6 8h4" />
      <path d="M6 10.5h2.5" />
    </svg>
  );
}

export function WitnessLogIcon() {
  return (
    <svg {...baseProps}>
      <rect x="2" y="3" width="12" height="10" rx="1.5" />
      <path d="M4.5 6h7" />
      <path d="M4.5 8.5h7" />
      <path d="M4.5 11h4" />
    </svg>
  );
}

export function BillingIcon() {
  return (
    <svg {...baseProps}>
      <rect x="2" y="4" width="12" height="9" rx="1.5" />
      <path d="M2 7h12" />
      <path d="M4.5 10.5h2" />
    </svg>
  );
}

export function SettingsIcon() {
  return (
    <svg {...baseProps}>
      <circle cx="8" cy="8" r="2" />
      <path d="M8 1.5v2" />
      <path d="M8 12.5v2" />
      <path d="M1.5 8h2" />
      <path d="M12.5 8h2" />
      <path d="M3.4 3.4l1.4 1.4" />
      <path d="M11.2 11.2l1.4 1.4" />
      <path d="M3.4 12.6l1.4-1.4" />
      <path d="M11.2 4.8l1.4-1.4" />
    </svg>
  );
}
